import { useState } from "react";
import {
  FaUser,
  FaBuilding,
  FaUserTie,
  FaTools,
  FaWindowRestore,
  FaFileAlt,
} from "react-icons/fa";
import { Toast } from "../../common/Toast";
import CustomerReport from "./CustomerReport";
import SitesReport from "./SiteReport";
import ArchitectReport from "./ArchitectReport";
import WindowReport from "./WindowReport";
import ManualReport from "./ManualReport";
import MaterialReport from "./MaterialReport";
import FabricatorReport from "./FabricatorReport";

const menuItems = [
  { name: "Customer", icon: <FaUser /> },
  { name: "Architect", icon: <FaUserTie /> },
  { name: "Fabricator", icon: <FaTools /> },
  { name: "Site", icon: <FaBuilding /> },
  { name: "Window Quotation", icon: <FaWindowRestore /> },
  { name: "Manual Quotation", icon: <FaFileAlt /> },
  { name: "Material Quotation", icon: <FaFileAlt /> },
];

const Reports = () => {
  const [selectedItem, setSelectedItem] = useState("Customer");
  const filteredItems = menuItems.filter((item) => item.name.toLowerCase());

  const renderReportComponent = () => {
    switch (selectedItem) {
      case "Customer":
        return <CustomerReport />;
      case "Site":
        return <SitesReport />;
      case "Architect":
        return <ArchitectReport />;
      case "Fabricator":
        return <FabricatorReport />;
      case "Window Quotation":
        return <WindowReport />;
      case "Manual Quotation":
        return <ManualReport />;
      case "Material Quotation":
        return <MaterialReport />;
      default:
        return (
          <p className="text-gray-500">
            Type something to search reports or click on any section to view
            report list.
          </p>
        );
    }
  };

  return (
    <>
      <Toast />
      <div className="flex h-[calc(100vh-85px)] bg-slate-50/50 rounded-2xl border border-slate-200 overflow-hidden shadow-sm m-4">
        {/* Sidebar */}
        <div className="w-72 bg-white border-r border-slate-100 flex flex-col">
          <div className="p-6 border-b border-slate-50">
            <h2 className="text-xs font-black text-slate-400 uppercase tracking-widest">Report Categories</h2>
          </div>
          <div className="flex-1 overflow-y-auto p-4 space-y-1 custom-scrollbar">
            {filteredItems.map((item, index) => (
              <button
                key={index}
                onClick={() => setSelectedItem(item.name)}
                className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-xl transition-all duration-300 group ${selectedItem === item.name
                    ? "bg-primary text-white shadow-lg shadow-primary/20 scale-[1.02]"
                    : "text-slate-500 hover:bg-slate-50 hover:text-slate-900"
                  }`}
              >
                <span className={`p-2 rounded-lg transition-all ${selectedItem === item.name
                    ? "bg-white/20 text-white"
                    : "bg-slate-100 text-slate-400 group-hover:bg-white group-hover:text-primary group-hover:shadow-sm"
                  }`}>
                  {item.icon}
                </span>
                <span className="text-xs font-bold tracking-wide uppercase">{item.name}</span>
                {selectedItem === item.name && (
                  <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-hidden bg-slate-50 relative">
          <div className="absolute inset-0 overflow-y-auto p-8 custom-scrollbar">
            <div className="max-w-7xl mx-auto">
              {renderReportComponent()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
